module.exports = __webpack_public_path__ + "img/img17.b98396ef.svg";